import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, useLocation, Outlet, useParams, json } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { Setlib } from './store.js';
import { User } from './user.js';
import { User as UserModal } from './user.js';

import Nav from 'react-bootstrap/Nav';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import { getAllByAltText } from '@testing-library/react';
import { Col } from 'react-bootstrap';

function Lib() {

  const store = useSelector((state) => state);
  const bootstrap = require('bootstrap')

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  let { pw } = useParams();

  let [admin, adminSet] = useState(pw == 'cresoul');

  useEffect(() => {

  }, [])


  return (
    <div>
      {User('all', 'lib')}


      <Modal show={store.lib.modal} fullscreen={true} onHide={() => dispatch(Setlib(false))} backdrop={true}>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title>유저 정보</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className='width-sm margin-auto'>
            {UserModal(store.lib.uuid, 'libmodal')}
          </div>
        </Modal.Body>
      </Modal>



    </div>


  )
}


export default Lib;